import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 md:px-6 lg:px-8 pt-8 pb-24 max-w-5xl" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 text-sm text-red-600"
}
const _hoisted_3 = { class: "mb-8 rounded-xl border border-catering-cream-300 bg-catering-cream-100 px-6 py-5" }
const _hoisted_4 = { class: "flex items-start gap-4" }
const _hoisted_5 = {
  class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-catering-md bg-gradient-to-br from-catering-lemon to-catering-lemon-300 shadow-catering-xs",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "mt-4 grid gap-3 sm:grid-cols-3" }
const _hoisted_7 = { class: "flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-catering-ink-900 text-[11px] font-semibold text-catering-lemon" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = { class: "block text-sm font-medium text-gray-900" }
const _hoisted_10 = { class: "block text-xs text-gray-500" }
const _hoisted_11 = { class: "flex items-center gap-3" }
const _hoisted_12 = { class: "text-sm text-gray-500" }
const _hoisted_13 = {
  key: 0,
  class: "px-6 py-4"
}
const _hoisted_14 = { class: "flex items-start gap-2 rounded-md bg-gray-50 p-3 text-sm text-gray-600" }
const _hoisted_15 = { class: "grid items-start gap-6 px-6 py-5 lg:grid-cols-[minmax(0,1fr)_320px] lg:gap-7" }
const _hoisted_16 = { class: "mt-3.5 space-y-2" }
const _hoisted_17 = { class: "w-full max-w-[340px] lg:max-w-none" }
const _hoisted_18 = { class: "mt-2.5 flex items-center gap-1.5 text-xs text-gray-500" }
const _hoisted_19 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_20 = { class: "min-w-0 break-all font-mono text-sm text-gray-700" }
const _hoisted_21 = { class: "flex flex-wrap gap-2" }
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_23 = { class: "flex items-center gap-3" }
const _hoisted_24 = { class: "text-sm text-gray-500" }
const _hoisted_25 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_26 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_27 = { class: "flex items-center gap-3" }
const _hoisted_28 = { class: "text-sm text-gray-500" }
const _hoisted_29 = { class: "px-6 py-4" }
const _hoisted_30 = {
  key: 0,
  class: "mt-4"
}

import {
  ArrowTopRightOnSquareIcon,
  CheckIcon,
  ClipboardDocumentIcon,
  EyeIcon,
  InformationCircleIcon
} from '@heroicons/vue/20/solid'
import { QrCodeIcon } from '@heroicons/vue/24/outline'
import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

import ImageUploaderNeue from '@/components/neue/ImageUploaderNeue.vue'
import InputArea from '@/components/neue/InputArea.vue'
import InputField from '@/components/neue/InputField.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeueToggle from '@/components/neue/NeueToggle.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import SettingCard from '@/components/settings/SettingCard.vue'
import SettingRow from '@/components/settings/SettingRow.vue'
import LeadCapturePreview from '@/components/storefront/LeadCapturePreview.vue'
import LeadCaptureQrCode from '@/components/storefront/LeadCaptureQrCode.vue'
import { useAutosave } from '@/composables/useAutosave'
import { useLeadCaptureReveal } from '@/composables/useLeadCaptureReveal'
import { useLeadCaptureTabs } from '@/composables/useLeadCaptureTabs'
import { useToast } from '@/composables/useToast'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'
import ChannelReportLink from '@/view/ai/ChannelReportLink.vue'
import LeadCaptureEmbed from '@/view/storefront/LeadCaptureEmbed.vue'

const MAX_LOGO_BYTES = 2 * 1024 * 1024
const COPIED_FOR_MS = 2000
const LOAD_ERROR = "Couldn't load your lead capture settings. Please refresh the page."
const SAVE_ERROR = "Couldn't save your changes. Please try again."
const STALE_TIER_PLACEHOLDER = "Your saved tier can't be used any more - choose another"
const LOGO_NOTE_SHAPE = 'PNG or JPG up to 2MB. Wide or square both work - we fit it without cropping.'
const PREVIEW_NOTE = 'Updates as you type. A new logo shows here once you save.'


export default {
  __name: 'LeadCaptureSettings',
  setup(__props) {

const LOGO_NOTE_WITH_FALLBACK = `${LOGO_NOTE_SHAPE} Uses your storefront logo if you don't upload one.`
const LOGO_NOTE_WITHOUT_FALLBACK = `${LOGO_NOTE_SHAPE} No logo will show until you upload one.`
const INTRO_STEPS = [
  { title: 'Share it', body: 'Print the QR code or send the link.' },
  { title: 'They sign up', body: 'Name and mobile number, on any phone.' },
  { title: 'You follow up', body: 'They get a text and join your customer list.' }
]

const BENEFITS = [
  'Works on any phone, with nothing to install',
  'Texts them straight away to confirm',
  'Counts scans and link visits separately'
]

const { showToast } = useToast()
const { tabs, tab } = useLeadCaptureTabs()
useLeadCaptureReveal()
const canUpdateSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'update'))

const loading = ref(true)
const loadError = ref('')
const page = ref(null)
const logoChange = ref(null)
const uploaderKey = ref(0)
const copied = ref(false)
const previewOpen = ref(false)
const reportSummary = ref(null)
let copiedTimer = null

const form = reactive({
  enabled: false,
  headline: '',
  description: '',
  collect_email: true,
  show_logo: false,
  default_membership_tier_id: null
})

const attributes = computed(() => page.value?.attributes ?? {})
const pageUrl = computed(() => attributes.value.page_url || null)
const displayUrl = computed(() => (pageUrl.value ?? '').replace(/^https?:\/\//, ''))
const qrUrl = computed(() => (pageUrl.value ? `${pageUrl.value}?via=qr` : null))
const logoFiles = computed(() => {
  const logo = mapRelationship(page.value?.relationships?.logo?.data)
  return logo ? [logo] : []
})
const tierOptions = computed(() => [
  { name: 'No tier', value: null },
  ...(attributes.value.eligible_membership_tiers ?? []).map(tier => ({ name: tier.name, value: tier.id }))
])
const staleTierPlaceholder = computed(() => {
  const savedTierId = attributes.value.default_membership_tier_id
  if (savedTierId === null) return undefined
  const stillEligible = (attributes.value.eligible_membership_tiers ?? []).some(tier => tier.id === savedTierId)
  return stillEligible ? undefined : STALE_TIER_PLACEHOLDER
})
const logoNote = computed(() =>
  attributes.value.storefront_logo_url ? LOGO_NOTE_WITH_FALLBACK : LOGO_NOTE_WITHOUT_FALLBACK
)

const status = computed(() => {
  if (!pageUrl.value) return { dot: 'bg-gray-300', label: 'No web address yet' }
  if (!form.enabled) return { dot: 'bg-gray-300', label: 'Switched off' }
  if (saving.value) return { dot: 'bg-amber-400', label: 'Switching on...' }
  return { dot: 'bg-green-500', label: 'Taking signups' }
})

const previewLogoUrl = computed(() => {
  if (!form.show_logo) return null

  const storefrontLogo = attributes.value.storefront_logo_url || null
  if (logoChange.value?._destroy) return storefrontLogo
  return attributes.value.logo_url || storefrontLogo
})

const previewProps = computed(() => ({
  headline: form.headline.trim() || attributes.value.headline_default,
  description: form.description.trim() || attributes.value.description_default,
  logoUrl: previewLogoUrl.value,
  consentText: attributes.value.consent_text ?? '',
  pageUrl: pageUrl.value,
  brandColor: attributes.value.brand_color ?? null,
  collectEmail: form.collect_email
}))

const apply = response => {
  const record = response.data.data
  page.value = record
  form.enabled = record.attributes.enabled
  form.headline = record.attributes.headline ?? ''
  form.description = record.attributes.description ?? ''
  form.collect_email = record.attributes.collect_email
  form.show_logo = record.attributes.show_logo
  form.default_membership_tier_id = record.attributes.default_membership_tier_id ?? null
  logoChange.value = null
  uploaderKey.value += 1
}

const load = () => api.call('GET', 'lead_capture_page').then(apply)

const loadReportSummary = () =>
  api
    .call('GET', 'lead_capture_page/report_summary')
    .then(response => {
      reportSummary.value = response?.data ?? null
    })
    .catch(() => {
      reportSummary.value = null
    })

const loadFailed = () => {
  loadError.value = LOAD_ERROR
}

const payload = () => ({
  enabled: form.enabled,
  headline: form.headline.trim() || null,
  description: form.description.trim() || null,
  collect_email: form.collect_email,
  show_logo: form.show_logo,
  default_membership_tier_id: form.default_membership_tier_id,
  ...(logoChange.value && { logo_attributes: logoChange.value })
})

const fingerprint = () => JSON.stringify(payload())

const persist = () => {
  const sentLogo = logoChange.value

  return api.call('PUT', 'lead_capture_page', { lead_capture_page: payload() }).then(response => {
    page.value = response.data.data
    if (sentLogo && logoChange.value === sentLogo) {
      logoChange.value = null
      uploaderKey.value += 1
    }
    return fingerprint()
  })
}

const { pending: saving, failed: saveFailed, schedule, flush, reset } = useAutosave({ fingerprint, persist })

watch([form, logoChange], () => canUpdateSite.value && schedule(), { deep: true })

watch(saveFailed, error => {
  if (!error) return
  showToast(error.response?.data?.errors?.[0] || SAVE_ERROR, { type: 'error' })
})

const holdUnload = event => {
  if (!saving.value) return
  event.preventDefault()
  event.returnValue = ''
}

onBeforeRouteLeave(() => flush())

const copyLink = async () => {
  if (!pageUrl.value) return
  try {
    await navigator.clipboard.writeText(pageUrl.value)
  } catch {
    showToast("Couldn't copy the link", { type: 'error' })
    return
  }
  copied.value = true
  clearTimeout(copiedTimer)
  copiedTimer = setTimeout(() => {
    copied.value = false
  }, COPIED_FOR_MS)
}

const openPage = () => {
  if (!pageUrl.value) return
  window.open(attributes.value.preview_url, '_blank', 'noopener')
}

onMounted(() => {
  window.addEventListener('beforeunload', holdUnload)
  load()
    .then(reset)
    .catch(loadFailed)
    .finally(() => {
      loading.value = false
    })
  loadReportSummary()
})

onBeforeUnmount(() => {
  window.removeEventListener('beforeunload', holdUnload)
  clearTimeout(copiedTimer)
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, {
        text: "Lead capture",
        "save-status": true,
        sections: _unref(tabs)
      }, null, 8, ["sections"])
    ]),
    main: _withCtx(() => [
      _createVNode(NeueLoading, { loading: loading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (loadError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(loadError.value), 1))
              : _createCommentVNode("", true),
            (page.value && _unref(tab) === 'page')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("section", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _createVNode(_unref(QrCodeIcon), { class: "h-5 w-5 text-catering-ink-900" })
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("h2", { class: "text-base font-semibold text-gray-900" }, "Collect signups anywhere, with one link"),
                        _createElementVNode("p", { class: "mt-1 text-sm text-gray-600" }, " Print the QR code for a market stall or an event, or send the link. Everyone who signs up joins your customer list and gets a text to confirm it. ")
                      ], -1))
                    ]),
                    _createElementVNode("ol", _hoisted_6, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(INTRO_STEPS, (step, index) => {
                        return _createElementVNode("li", {
                          key: step.title,
                          class: "flex items-start gap-2.5 rounded-lg bg-white/80 px-3 py-2.5 ring-1 ring-catering-cream-300"
                        }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(index + 1), 1),
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(step.title), 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(step.body), 1)
                          ])
                        ])
                      }), 64))
                    ])
                  ]),
                  _createVNode(SettingCard, { name: "Lead capture page" }, {
                    action: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(NeueToggle, {
                          modelValue: form.enabled,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.enabled) = $event)),
                          compact: "",
                          disabled: !canUpdateSite.value
                        }, null, 8, ["modelValue", "disabled"]),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(form.enabled ? 'On' : 'Off'), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      (!form.enabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_unref(InformationCircleIcon), {
                                class: "mt-0.5 h-4 w-4 shrink-0 text-gray-400",
                                "aria-hidden": "true"
                              }),
                              _cache[9] || (_cache[9] = _createElementVNode("span", null, [
                                _createElementVNode("b", { class: "font-medium text-gray-900" }, "Your page is switched off, so nobody can sign up."),
                                _createTextVNode(" Switch it on to start collecting. ")
                              ], -1))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm text-gray-500" }, " One page that asks for a name and a mobile number. Share it as a link or a QR code. ", -1)),
                          _createElementVNode("ul", _hoisted_16, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(BENEFITS, (benefit) => {
                              return _createElementVNode("li", {
                                key: benefit,
                                class: "flex items-start gap-2 text-sm text-gray-700"
                              }, [
                                _createVNode(_unref(CheckIcon), {
                                  class: "mt-0.5 h-4 w-4 shrink-0 text-gray-400",
                                  "aria-hidden": "true"
                                }),
                                _createElementVNode("span", null, _toDisplayString(benefit), 1)
                              ])
                            }), 64))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["transition duration-200", !form.enabled && 'opacity-50 grayscale'])
                          }, [
                            _createVNode(LeadCapturePreview, _mergeProps({ size: "mini" }, previewProps.value), null, 16)
                          ], 2),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["h-1.5 w-1.5 shrink-0 rounded-full", status.value.dot]),
                              "aria-hidden": "true"
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(status.value.label), 1)
                          ])
                        ])
                      ]),
                      (form.enabled)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(SettingRow, {
                              label: "Page link",
                              hint: "Send it in a message, an email or a post"
                            }, {
                              default: _withCtx(() => [
                                (pageUrl.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createElementVNode("p", _hoisted_20, _toDisplayString(displayUrl.value), 1),
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(NeueButton, {
                                          type: "secondary",
                                          size: "sm",
                                          onClick: copyLink
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ClipboardDocumentIcon), {
                                              class: "mr-1.5 h-4 w-4",
                                              "aria-hidden": "true"
                                            }),
                                            _createTextVNode(" " + _toDisplayString(copied.value ? 'Copied' : 'Copy link'), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(NeueButton, {
                                          type: "secondary",
                                          size: "sm",
                                          onClick: openPage
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ArrowTopRightOnSquareIcon), {
                                              class: "mr-1.5 h-4 w-4",
                                              "aria-hidden": "true"
                                            }),
                                            _cache[11] || (_cache[11] = _createTextVNode(" Open page ", -1))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_22, " Your storefront needs a web address before you can share this page. "))
                              ]),
                              _: 1
                            }),
                            (pageUrl.value)
                              ? (_openBlock(), _createBlock(SettingRow, {
                                  key: 0,
                                  label: "QR code",
                                  hint: "Scans are counted separately from link visits"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(LeadCaptureQrCode, {
                                      url: qrUrl.value,
                                      enabled: form.enabled
                                    }, null, 8, ["url", "enabled"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(ChannelReportLink, {
                        summary: reportSummary.value?.page,
                        days: reportSummary.value?.days,
                        to: "/storefront/lead-capture/report",
                        "empty-text": "See how many signups turn into paid orders."
                      }, null, 8, ["summary", "days"])
                    ]),
                    _: 1
                  }),
                  _createVNode(SettingCard, { name: "Page content" }, {
                    default: _withCtx(() => [
                      _createVNode(SettingRow, {
                        label: "Show a logo",
                        hint: "At the top of the page, above your headline"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(NeueToggle, {
                              modelValue: form.show_logo,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((form.show_logo) = $event)),
                              compact: "",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "disabled"]),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(form.show_logo ? 'On' : 'Off'), 1)
                          ]),
                          (form.show_logo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_openBlock(), _createBlock(ImageUploaderNeue, {
                                  key: uploaderKey.value,
                                  files: logoFiles.value,
                                  retained: true,
                                  multiple: false,
                                  editable: canUpdateSite.value,
                                  "max-file-size": MAX_LOGO_BYTES,
                                  "placeholder-url": attributes.value.storefront_logo_url,
                                  accept: "image/png,image/jpeg",
                                  onChange: _cache[2] || (_cache[2] = $event => (logoChange.value = $event))
                                }, null, 8, ["files", "editable", "placeholder-url"])),
                                _createElementVNode("p", _hoisted_26, _toDisplayString(logoNote.value), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(SettingRow, {
                        label: "Headline",
                        hint: "Main title on the page"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(InputField, {
                            modelValue: form.headline,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((form.headline) = $event)),
                            "aria-label": "Headline",
                            placeholder: attributes.value.headline_default,
                            disabled: !canUpdateSite.value
                          }, null, 8, ["modelValue", "placeholder", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(SettingRow, {
                        label: "Description",
                        hint: "Short tagline beneath the headline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(InputArea, {
                            modelValue: form.description,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((form.description) = $event)),
                            rows: 3,
                            placeholder: attributes.value.description_default,
                            disabled: !canUpdateSite.value
                          }, null, 8, ["modelValue", "placeholder", "disabled"])
                        ]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bg-gray-50 px-6 py-3 text-sm text-gray-500" }, [
                        _createTextVNode(" Always collected: "),
                        _createElementVNode("span", { class: "font-medium text-gray-700" }, "First name, Last name, Mobile number")
                      ], -1)),
                      _createVNode(SettingRow, {
                        label: "Collect email address",
                        hint: "Show an optional email field"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(NeueToggle, {
                              modelValue: form.collect_email,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((form.collect_email) = $event)),
                              compact: "",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "disabled"]),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(form.collect_email ? 'On' : 'Off'), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(SettingRow, {
                        label: "Default membership tier",
                        hint: "New customers who sign up are added to this tier. Tiers with a subscription, meal plan or fee aren't listed."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SelectInput, {
                            modelValue: form.default_membership_tier_id,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((form.default_membership_tier_id) = $event)),
                            "aria-label": "Default membership tier",
                            options: tierOptions.value,
                            placeholder: staleTierPlaceholder.value,
                            disabled: !canUpdateSite.value
                          }, null, 8, ["modelValue", "options", "placeholder", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(NeueButton, {
                          type: previewOpen.value ? 'cream' : 'ghost',
                          size: "sm",
                          "aria-expanded": previewOpen.value,
                          onClick: _cache[7] || (_cache[7] = $event => (previewOpen.value = !previewOpen.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(EyeIcon), {
                              class: "mr-1.5 h-4 w-4",
                              "aria-hidden": "true"
                            }),
                            _cache[12] || (_cache[12] = _createTextVNode(" Preview page ", -1))
                          ]),
                          _: 1
                        }, 8, ["type", "aria-expanded"]),
                        (previewOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createVNode(LeadCapturePreview, _mergeProps({ size: "full" }, previewProps.value), null, 16),
                              _createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, _toDisplayString(PREVIEW_NOTE))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : (page.value)
                ? (_openBlock(), _createBlock(LeadCaptureEmbed, {
                    key: 2,
                    "report-summary": reportSummary.value
                  }, null, 8, ["report-summary"]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}